import React from "react";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Button, Col, Divider, Popconfirm, Row, Timeline } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { PaperClipOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
//utils & ducks
import { openNotification } from "../../../utils";
import * as uiText from "../../../utils";
import * as ducks from "../../../redux/aspirante/reqAcademicoDuck";

/**
 * Componente que muestra el listado de los requsitos académicos del aspirante
 * @param {function} showModal Para mostrar u ocultar el modal
 * @param {object} form Para manejar el formulario, proviene del useForm
 * @returns JSX.Element Timeline de la lista de los requisitos académicos
 */
export const HisAcademico = ({ showModal, form }) => {
  const dispatch = useDispatch();
  const { historial } = useSelector((state) => state.reqAcademico);
  const { nivelEstudios, areaAcademica, gradoAvance, docObtenido } =
    useSelector((state) => state.catalogos);
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );

  /**
   * Función que elimina un requisito académico de la lista y sus archivos
   * @param {object} { idAspirante, idEscolaridad, rutaArchivo }
   */
  const removeReqAcademicoById = (item) => {
    const { idAspirante, idEscolaridad, rutaArchivo } = item;
    const json = { idAspirante, idEscolaridad, rutaArchivo };

    // if (historial.length < 2) {
    //   openNotification("info", "Atención", uiText.REQ_LIMITE);
    //   return;
    // }
    dispatch(ducks.removeReqAcademico(json));
  };

  /**
   * Función que manda los valores al formulario del modal para su respectiva edición
   * @param {object} requisito object del formulario del modal
   */
  const activeReqAcademico = (req) => {
    dispatch(ducks.isActiveReqAcademico(req)); //se almacena en el state
    //Llenar el formulario
    form.setFieldsValue({ nivEstudio: String(req.idNivEstudio) });
    form.setFieldsValue({ area: String(req.idAreaAcademica) });
    form.setFieldsValue({ carrera: req.carrera && req.carrera });
    form.setFieldsValue({ grado: String(req.idGrado) });
    form.setFieldsValue({ documento: String(req.idDocumento) });
    form.setFieldsValue({ archivo: req.nombreArchivoOriginal });
    //open modal
    showModal();
  };

  /**
   * Función que permite descargar el documento de requisito académico
   * @param {object} item
   */
  const downloadDocument = (item) => {
    const { rutaArchivo, nombreArchivoOriginal } = item;
    dispatch(ducks.setLoading(true));
    //Se envía la ruta del archivo
    dispatch(ducks.download(rutaArchivo))
      .then(({ data }) => {
        data && saveAs(new Blob([data]), nombreArchivoOriginal);
        dispatch(ducks.setLoading(false));
      })
      .catch((error) => {
        openNotification("warning", "Atención", uiText.ERROR_ARCHIVO);
        dispatch(ducks.setLoading(false));
      });
  };

  /**
   * Función que abre una nueva pestaña para poder visualizar el documento
   * @param {object} item
   */
  const openTabDocument = (item) => {
    const { rutaArchivo } = item;
    dispatch(ducks.setLoading(true));
    dispatch(ducks.download(rutaArchivo))
      .then(({ data }) => {
        let fileURL = window.URL.createObjectURL(data);
        window.open(fileURL);
        dispatch(ducks.setLoading(false));
      })
      .catch((error) => {
        openNotification("warning", "Atención", uiText.ERROR_ARCHIVO);
        dispatch(ducks.setLoading(false));
      });
  };

  /**
   * Función que limpia el formulario y muestra el modal
   */
  const openModal = () => {
    form.resetFields();
    showModal();
  };

  /**
   * Función que recupera el texto del combo seleccionado
   * @param {number} idItem id seleccionado
   * @param {Array} array Areeglo del combo a obtener el nombre
   * @returns El texto de la opción seleccionada del combo del formulario
   */
  const getText = (idItem, array) =>
    array.find(({ id }) => id === +idItem)?.nombre;

  return (
    <div className="fondo-academico">
      <Timeline id="timeLine" style={{ marginTop: 10 }}>
        {historial.map((item, i) => (
          <Timeline.Item key={i}>
            <Row gutter={24}>
              <Col span={20}>
                <div className="titulo-academico">
                  {getText(item.idNivEstudio, nivelEstudios)}
                </div>
              </Col>
              <Col>
                {!bloquearPorFecha && !estatusPostulacion && (
                  <>
                    <Button
                      id="bntCircle"
                      shape="circle"
                      icon={<EditOutlined />}
                      onClick={() => activeReqAcademico(item)}
                    />{" "}
                    <Popconfirm
                      title={uiText.INFO_ELIMINAR}
                      onConfirm={() => removeReqAcademicoById(item)}
                      okText="Aceptar"
                      cancelText="Cancelar"
                    >
                      <Button
                        id="bntCircle"
                        shape="circle"
                        icon={<DeleteOutlined />}
                      />
                    </Popconfirm>
                  </>
                )}
              </Col>
            </Row>
            <div style={{ marginTop: 8 }}>
              <InfoAcademica
                subTitulo={"Área"}
                respuesta={getText(item.idAreaAcademica, areaAcademica)}
              />
              <InfoAcademica subTitulo={"Carrera"} respuesta={item.carrera} />
              <InfoAcademica
                subTitulo={"Grado de avance"}
                respuesta={getText(item.idGrado, gradoAvance)}
              />
            </div>
            <Divider />

            <InfoAcademica
              subTitulo={"Documento obtenido"}
              respuesta={getText(item.idDocumento, docObtenido)}
            />
            {item?.nombreArchivoOriginal && (
              <div className="show-archivo sub-titulo-academico">
                <Row>
                  <Col span={19}>
                    <PaperClipOutlined /> {item?.nombreArchivoOriginal}
                  </Col>
                  <Col>
                    <Button
                      type="link"
                      icon={<SearchOutlined style={{ color: "#d5007f" }} />}
                      onClick={(e) => openTabDocument(item)}
                    />
                  </Col>
                  <Col>
                    <Button
                      type="link"
                      icon={<DownloadOutlined style={{ color: "#d5007f" }} />}
                      onClick={(e) => downloadDocument(item)}
                    />
                  </Col>
                </Row>
              </div>
            )}
          </Timeline.Item>
        ))}

        <Timeline.Item>
          {/* {!bloquearPorFecha && (
            <>
              <Button type="link" onClick={openModal}>
                <span
                  className="btn-nuevo"
                  // style={{ cursor: "pointer" }}
                >
                  Agregar nueva escolaridad
                </span>
              </Button>
            </>
          )} */}
          <Button
            type="link"
            disabled={bloquearPorFecha || estatusPostulacion}
            className="btn-nuevo"
            onClick={openModal}
          >
            Agregar nueva escolaridad
          </Button>
        </Timeline.Item>
      </Timeline>
    </div>
  );
};

/**
 * Componente para mostrar las etiquetas del apartado de requisitos académicos
 * @param {string} subTitulo Label a mostrar
 * @param {respuesta} subTitulo Label a mostrar como respuesta
 * @returns JSX
 */
export const InfoAcademica = ({ subTitulo, respuesta }) => {
  return (
    <div className="sub-titulo-academico">
      {subTitulo}: <span className="res-academica">{respuesta}</span>
    </div>
  );
};
